import { H1 } from '@atoms/Typographies';
import { useCloseRequestList, useOpenRequestList } from '@hooks/Services';
import { Container, ContainerForFacility } from '@organisms/GenesisEs/Layouts';
import { CloseTableList, OpenTableList } from '@organisms/GenesisEs/List';
import Head from '@organisms/Heads/Head';
import Error from '@pages/Error';
import CommonTemplate from '@templates/Common';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

const timestamp = new Date().getTime();

const Facility = () => {
    const powerCustomerLocationNumber: any = useParams().id;
    if (!powerCustomerLocationNumber.match(/^(0[0-9]{21})$/)) {
        return (
            <Error
                message='供給地点番号は0から始まる22桁の半角数字を指定してください。'
            />
        );
    }
    const openRequestList = useOpenRequestList.useAllListData({
        requestCategory: '',
        contactId: '',
        powerCustomerLocationNumber: powerCustomerLocationNumber,
        relitRequestDate: { start: '', end: '' },
        relitDesiredDate: { start: '', end: '' },
        supplyStartDate: { start: '', end: '' },
        acceptStatus: [],
        systemClass: '0',
        responseStatus: '',
        timestamp: timestamp
    });
    const closeRequestList = useCloseRequestList.useAllListData({
        requestCategory: '',
        contactId: '',
        powerCustomerLocationNumber: powerCustomerLocationNumber,
        abolitionRequestDate: { start: '', end: '' },
        abolitionDesiredDate: { start: '', end: '' },
        supplyEndDate: { start: '', end: '' },
        demolitionDate: { start: '', end: '' },
        acceptStatus: [],
        systemClass: '0',
        responseStatus: '',
        timestamp: timestamp
    });
    return (
        <CommonTemplate>
            <Head title="設備情報" />
            <HeadingWithStyled className="mb-4">
                <H1>設備情報詳細</H1>
            </HeadingWithStyled>

            <ContainerForFacility
                powerCustomerLocationNumber={powerCustomerLocationNumber}
            />

            <Container 
                title="再点情報"
                children={<OpenTableList listData={openRequestList} />}
            />
            
            <Container
                title="廃止情報"
                children={<CloseTableList listData={closeRequestList} />}
            />

        </CommonTemplate>
    );
};

const HeadingWithStyled = styled.div`
`


export default Facility;
